import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';
import '@/modules/Finance/components/finance.css';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const AccountPage = lazy(() => import('./pages/Account'));
const DocumentsPage = lazy(() => import('./pages/Documents'));

/** Financeiro do médico (T-40) e documentos/notas/contrato (T-41), dentro do ambiente do médico (DoctorPanel). */
const routes: RouteObject[] = [
  { path: '/medico/financeiro', element: <RequireAuth roles={['DOCTOR']}><AccountPage /></RequireAuth> },
  { path: '/medico/documentos', element: <RequireAuth roles={['DOCTOR']}><DocumentsPage /></RequireAuth> },
];
export default routes;
